var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-item",style:({
    'background-image': ("url('" + (_vm.getImgUrl('publicMobile/bindbox2/img-box.png')) + "')")
  })},[_c('van-image',{staticClass:"box",attrs:{"width":"72px","height":"56px","src":_vm.good.imageUrl}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.good.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }